export default __webpack_public_path__ + "static/media/an.80a0f22f.svg";